<template>
  <div class="country-page">
    <div class="country-info-container" v-if="country">
      <div class="page-header">
        <h1>{{country.displayName}}</h1>
        <div class="header-intro" v-if="country.introText" v-html="country.introText"></div>
      </div>
      <div class="top-links">
        <a class="map-link" @click="showCountryMap">{{labels.countryMap}}</a>
        <a class="web-link" :href="country.countryPage" v-if="country.countryPage">{{labels.additionalInfo}}</a>
        <a class="doc-link" @click="showDocuments" v-if="country.documents">{{labels.documents}}</a>
        <router-link to="/" class="globe-link">{{labels.otherCountries}}</router-link>
      </div>
      <div class="location-container" v-if="country.locations && country.locations.length > 0">
        <Location v-for="l in country.locations" :key="l.id" :location="l"></Location>
      </div>
      <Modal :visible="showMap" @close="showMap = false" :title="country.displayName" v-if="showMap">
        <Map :pins="country.locations"></Map>
      </Modal>
      <Modal @close="showDownloads = false" :title="labels.downloads" v-if="showDownloads" :visible="showDownloads">
        <download-box :files="country.documents"></download-box>
      </Modal>
    </div>
    <div class="not-found" v-if="notFound">
        <p>{{labels.countryNotFound}}</p>
        <router-link to="/" class="globe-link vector-icon" v-if="!country">{{labels.allCountries}}</router-link>
    </div>
  </div>
</template>

<script>
import {Utils, State, DataLayer, Labels, Monitoring} from "../services.js";
import Location from "./Location.vue";
import Modal from "./Modal.vue";
import Map from "./Map.vue";
import DownloadBox from "./DownloadBox.vue";

export default {
  name: 'CountryPage',
  components: {
    Location,
    Modal, 
    Map,
    DownloadBox
  },
  data () {
    return {
      labels: Labels,
      countryName: this.$route.params.name.replace(/\-/g, " "),
      country: null,
      notFound: false,
      showMap: false,
      showDownloads: false
    }
  },
  mounted() {
    State.subscribe("CountryPage", this.onStateChange);
    this.loadCountryInfo();
  },
  beforeDestroy() {
    State.unsubscribe("CountryPage");
  },
  methods: {
    loadCountryInfo() {
      if (!this.countryName) return;
      //first, we check the state to see if we already have the info for this country
      //thenwe check the state to get the country id
      //then, if available, we load the country info
      
      const country = State.get(this.countryName);
      if (country) {
        console.log("Country information found in the State");
        this.country = country;
        this.notFound = false;
        return;
      }
      const countries = State.get("countries");
      if (!countries || countries.length === 0) {
        console.log("Country list not available yet.");
        return;
      }
      let info = countries.find(x => x.name === this.countryName);
      if (!info) {
        this.notFound = true;
        return;
      }
      let loader = Utils.showLoader(".country-page");
      Monitoring.startActivity("Country information loading");
      DataLayer.getCountryInfo(info.id).then(res => {
        State.set(this.countryName, res.data);
        this.notFound = false;
      }).catch(err => {
        Utils.showStatusMessage(`Could not load country information! ${err}.`,"red",5000);
      }).finally(() => {
        Utils.removeLoader(loader);
        Monitoring.endActivity("Country information loading");
      });
    },
    onStateChange(message, prop, value) {
      if (!value) return;
      console.log(`State changed. Re-loading country info.`);
      this.loadCountryInfo();
    },
    showCountryMap() {
      this.showMap = true;
    },
    showDocuments() {
      this.showDownloads = true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.morelink {
  display: flex;
  align-items: center;
  line-height:16px;
  margin-bottom: 5px;
}

.top-links {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background-color: #f0f0f0;
  margin-bottom: 40px;
  background-color: #f0f0f0;
  padding: 10px 0;

}

.top-links > a {
  margin: 0 20px;
  display: block;
  font-weight: 500;
  padding-left: 25px;
  cursor: pointer;
  background-position: 0 50%;
  background-repeat: no-repeat;
}

.location-container {
  display: flex;
  flex-wrap: wrap;
}

.location-container > .location {
  width: 50%;
}

@media all and (max-width:780px){
 .location-container > .location {
    width: 100%;
  } 
}
</style>
